import { useState } from "react";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;
`;

const DropdownButton = styled.div`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid ${colors.dash};
  border-radius: 6px;
  font-size: 15px;
  background: white;
  cursor: pointer;
  transition: border 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: #666;
  }

  &.open {
    border-color: #666;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
  }
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 6px 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
`;

const DropdownItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;

const Dropdown = ({ value, onChange, options, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <DropdownContainer>
      <DropdownButton
        className={isOpen ? "open" : ""}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {value || placeholder || "Select an option"}
      </DropdownButton>

      {isOpen && (
        <DropdownList>
          {options.map((option) => (
            <DropdownItem key={option} onClick={() => handleSelect(option)}>
              {option}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default Dropdown;
